var _curry2 = require('./internal/_curry2');


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> * -> *
 * @param {Boolean} a A boolean value
 * @param {Boolean} b A boolean value
 * @return {Boolean} `true` if one or both arguments are `true`, `false` otherwise
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
module.exports = _curry2(function or(a, b) {
  return a || b;
});



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/or.js
 ** module id = 258
 ** module chunks = 0
 **/